import React from "react";
import {
  FaBars,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaSignOutAlt,
  FaMoon,
  FaSun,
} from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import { useNavigate, useLocation } from "react-router-dom";

const TITLE_MAP = {
  "/": "Dashboard",
  "/users": "Users",
  "/exchangers": "Exchangers",
  "/settings": "Settings",
  "/deposits": "Deposits",
  "/withdrawals": "Withdrawals",
  "/p2p-transfer-list": "P2P Transfers",
  "/p2p-withdrawal-list": "P2P Withdrawals",
  "/swap-history": "Swap History",
  "/p2p-report": "P2P History",
  "/trade-list": "Trade List",
  "/trade-history": "Trade History",
  "/live-trades-all": "Live Trades",
  "/salary": "Salary",
  "/bonus": "Bonus",
  "/leader-list": "Leader List",
  "/recovery-trade": "Recovery",
  "/recovery-trade-history": "Recovery History",
  "/coupon": "Coupon",
  "/stats-trade": "Trade Statistics",
  "/stats-transaction": "Transaction Statistics",
};

function resolveTitle(pathname) {
  if (TITLE_MAP[pathname]) return TITLE_MAP[pathname];
  if (pathname.startsWith("/user-profile/")) return "User Profile";
  if (pathname.startsWith("/live-trades/")) return "Live Trade";
  if (pathname.startsWith("/leader-stats/")) return "Leader Stats";
  if (pathname.startsWith("/user-downline-report/")) return "Downline Report";
  return "Admin";
}

export default function NavbarTop({
  onMenu,
  sidebarCollapsed,
  onToggleSidebarCollapse,
}) {
  const { logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const username = (localStorage.getItem("iutyeurds") || "Admin").trim();
  const initials = username.slice(0, 2) || "AD";
  const pageTitle = resolveTitle(location.pathname);

  const onLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <nav className="navbar navbar-expand tb-navbar">
      <div className="container-fluid px-2 px-md-3">
        <div className="d-flex align-items-center gap-2">
          <button
            className="tb-icon-btn d-lg-none"
            onClick={onMenu}
            type="button"
            aria-label="Open menu"
          >
            <FaBars />
          </button>

          <button
            className="tb-icon-btn d-none d-lg-inline-flex"
            onClick={onToggleSidebarCollapse}
            type="button"
            aria-label={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {sidebarCollapsed ? <FaAngleDoubleRight /> : <FaAngleDoubleLeft />}
          </button>

          <div className="d-none d-md-block">
            <div className="navbar-brand mb-0 py-0">{pageTitle}</div>
            <div className="tb-page-crumb">TradeBid Admin</div>
          </div>

          <div className="d-md-none d-flex align-items-center gap-2">
            <span className="tb-brand-mark">TB</span>
            <span className="navbar-brand mb-0 py-0">{pageTitle}</span>
          </div>
        </div>

        <div className="ms-auto d-flex align-items-center gap-2">
          <button
            className="tb-icon-btn"
            type="button"
            onClick={toggleTheme}
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            title={theme === "dark" ? "Light mode" : "Dark mode"}
          >
            {theme === "dark" ? <FaSun /> : <FaMoon />}
          </button>

          <div className="tb-user-chip d-none d-sm-inline-flex">
            <span className="tb-user-avatar">{initials}</span>
            <div className="lh-sm pe-1">
              <div className="small" style={{ lineHeight: 1.15, fontWeight: 500, color: "var(--tb-ink)" }}>
                {username}
              </div>
              <div className="text-muted" style={{ fontSize: "0.65rem" }}>
                Admin
              </div>
            </div>
          </div>

          <button
            className="btn btn-outline-danger btn-sm tb-logout-btn d-inline-flex align-items-center gap-1"
            onClick={onLogout}
            type="button"
          >
            <FaSignOutAlt />
            <span className="d-none d-md-inline">Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
